<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/reset-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reset Password</h4>
                  <p>Please enter your new password.</p>
                </div>
                <vs-input
                  type="email"
                  label-placeholder="Email"
                  v-model="email"
                  readonly
                  class="w-full mb-6"
                />
                <vs-input
                  type="password"
                  label-placeholder="Password"
                  v-validate="'required|min:6'"
                  v-model="password"
                  class="w-full mb-6"
                />
                <span class="text-danger text-sm">{{ errors.first("password") }}</span>

                <vs-input
                  type="password"
                  label-placeholder="Confirm Password"
                  v-validate="'required|min:6'"
                  v-model="confirmpassword"
                  class="w-full mb-8"
                />
                <span class="text-danger text-sm">{{ errors.first("confirmpassword") }}</span>


                <div
                  class="flex flex-wrap justify-between flex-col-reverse sm:flex-row"
                >
                  <vs-button
                    type="border"
                    to="/pages/login"
                    class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                    >Go Back To Login</vs-button
                  >
                  <vs-button
                              @click="resetPassword"
                              :disabled="!validateForm"
                              class="w-full sm:w-auto">Reset</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";

export default {
  data () {
    return {
      usersId: "",
      id: "",
      email: "",
      password: "",
      confirmpassword: "",
      resetToken: ""
    };
  },
  computed: {
    validateForm () {
      return (
        !this.errors.any() &&

        this.password !== "" &&
        this.confirmPassword !== ""
      );
    }
  },
  methods: {
    resetPassword () {
      // If form is not validated or user is already login return
      if (!this.validateForm /*|| !this.checkLogin()*/) return; // to be done

      //console.log("User Verify Token", this.$route.params);


      this.$vs.loading();
      if(this.password===this.confirmpassword) {

        const payload = {
             id: this.$route.params.usersId,
            email: this.email,
            password: this.password,
            resetToken:"",
            resetExpires:new Date()

        };
        this.$store
          .dispatch("userManagement/resetPassword", payload)
          .then(res => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: i18n.t('notification.user.auth.resetPassword.success.r1'),
              text:  i18n.t('notification.user.auth.resetPassword.success.r2'),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "primary"
            });
            window.location.href = 'https://coach.getboarded.com/';
          })
          .catch(err => {
            this.$vs.notify({
              title: i18n.t('notification.user.auth.resetPassword.error.r1'),
              text:  i18n.t('notification.user.auth.resetPassword.error.r2'),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          });
      }
      else{
        this.$vs.notify({
          title: i18n.t('notification.user.auth.matchPassword.notMatch.n1'),
          text:  i18n.t('notification.user.auth.matchPassword.notMatch.n2'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }


    }
  },
  created () {
    this.resetToken = this.$route.params.resetToken;
    this.usersId = this.$route.params.usersId
    this.email = this.$route.params.userEmail;

    console.log("User Verify Token", this.resetToken, this.usersId,this.email);
    this.$store
      .dispatch("userManagement/fetchUser", this.usersId )
      .then(res => {

       // console.log('hello',res);
        if(res.resetToken.length==0) {
           window.location.href = 'https://coach.getboarded.com/';
        }

      })
      .catch(err => {
        this.$vs.notify({
          title: i18n.t('notification.user.auth.resetPassword.error.r1'),
          text:  i18n.t('notification.user.auth.resetPassword.error.r2'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });




  }
};
</script>
